module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "presentation-row"
  }, [_c('div', {
    staticClass: "presentation-row card between-md middle-md",
    class: {
      isSection: _vm.presentation.isSection
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h3', [_vm._v(_vm._s(_vm.presentation.title))]), _c('br'), _vm._v(" "), (_vm.presentation.isSection) ? _c('span', [_vm._v("Szekció")]) : _c('span', [_vm._v("Előadás")]), _c('br'), _vm._v("\n\t\t\t\t" + _vm._s(_vm.formatedDate(_vm.presentation.fromDate)) + " - " + _vm._s(_vm.formatedDate(_vm.presentation.toDate))), _c('br'), _vm._v(" "), (!_vm.presentation.isSection) ? _c('span', [_vm._v(_vm._s(_vm.formatedTime(_vm.presentation.fromDate)) + " - " + _vm._s(_vm.formatedTime(_vm.presentation.toDate)))]) : _vm._e()]), _vm._v(" "), (_vm.presentation.isSection) ? _c('div', {
    staticClass: "col-md-8 end-md"
  }, [(_vm.presentation.isSection) ? _c('md-button', {
    nativeOn: {
      "click": function($event) {
        _vm.create(_vm.presentation.fireId, false)
      }
    }
  }, [_vm._v("Előadás hozzadása")]) : _vm._e(), _vm._v(" "), (_vm.presentation.isSection) ? _c('md-button', {
    nativeOn: {
      "click": function($event) {
        _vm.create(_vm.presentation.fireId, true)
      }
    }
  }, [_vm._v("Alszekció hozzadása")]) : _vm._e(), _vm._v(" "), (_vm.presentation.isSection) ? _c('md-button', {
    nativeOn: {
      "click": function($event) {
        _vm.switchOpen()
      }
    }
  }, [_vm._v(_vm._s(_vm.open ? "Bezárás" : "Megnyitás"))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [(_vm.presentation.ratingCount > 0) ? _c('div', {
    staticClass: "ratings col-md-12"
  }, [_vm._v("\n\t\t\t\t\tÖsszes értékelés: "), _c('b', [_vm._v(_vm._s(_vm.presentation.ratingCount))]), _vm._v(" - \n\t\t\t\t\tÁtlagos értékelés: "), _c('b', [_vm._v(_vm._s(_vm.presentation.ratingAvg) + " / 6")])]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.presentation.comments).length > 0) ? _c('div', {
    staticClass: "comment col-md-12"
  }, [_vm._v("\n\t\t\t\t\tHozzászólások:\n\t\t\t\t\t"), _vm._l((_vm.presentation.comments), function(comment, userId) {
    return _c('p', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(comment) + "\n\t\t\t\t\t")])
  })], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row end-md"
  }, [_c('md-button', {
    staticClass: "md-warn",
    nativeOn: {
      "click": function($event) {
        _vm.remove(_vm.presentation)
      }
    }
  }, [_vm._v("Törlés")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.edit(_vm.presentation)
      }
    }
  }, [_vm._v("Szerkesztés")])], 1)]), _vm._v(" "), (_vm.open) ? _c('div', {
    staticClass: "subsections card"
  }, _vm._l((_vm.presentation.presentations), function(presentation) {
    return _c('div', [_c('presentation-row', {
      attrs: {
        "presentation": presentation,
        "depth": (_vm.depth + 1)
      }
    })], 1)
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17e51636!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/PresentationRow.vue
// module id = 549
// module chunks = 2